import { BEM } from "helpers/BEM.helper";
import React from "react";

const classes = new BEM({
  block: { name: "FetchBlurb" },
  elements: [{ name: "title" }, { name: "message" }],
});

export interface FetchBlurbProps {
  title: string;
  message: string;
}

export const FetchBlurb: React.FC<FetchBlurbProps> = (
  props: FetchBlurbProps,
) => {
  const { title, message } = props;
  return (
    <div
      className={`info-area info-horizontal ${classes.getBlockClassNames()}`}
    >
      <div className={"description"}>
        <h5 className={`info-title ${classes.getElementClassNames("title")}`}>
          {title}
        </h5>
        <p className={`description ${classes.getElementClassNames("message")}`}>
          {message}
        </p>
      </div>
    </div>
  );
};
